<template>
  <div class="enformzw">
    <div class="formheader">
      Hi，亲爱的用户，欢迎提交委托，为了让您获得更好的服务，以下各项均必填。如过程中遇到困难，请
      <span>联系我们</span> :)
    </div>
    <div class="enform-item flex">
      <div class="label">委托标题：</div>
      <div class="itinp">
        <el-input v-model="form.name"></el-input>
      </div>
      <div class="itemnote flex_start">
        <img src="../../../assets/entrust/inputsuccess.png" />
        请在此处填写案件标题，如：找擅长交通事故律师
      </div>
    </div>

    <div class="enform-item flex">
      <div class="label">案件描述：</div>
      <div class="itinp">
        <el-input
          type="textarea"
          resize="none"
          :rows="8"
          v-model="form.des"
        ></el-input>
      </div>
      <div class="itemnote flex_start">
        <img src="../../../assets/entrust/inputerrer.png" />
        请在此处详细描述案件情况及想要律师提供什么些帮助等，请勿填写当事人姓名等隐私内
        容，具体姓名可以用“张某或张X”代替。
      </div>
    </div>

    <div class="enform-item flex">
      <div class="label">特殊要求：</div>
      <div class="itinp">
        <el-input v-model="form.yq"></el-input>
      </div>
      <div class="itemnote flex_start">
        <img src="../../../assets/entrust/inputsuccess.png" />
        请在此处填写特殊要求，如：我想律师打电话主动 联系我
      </div>
    </div>

    <div class="enform-item flex">
      <div class="label">涉案地点：</div>
      <div class="itinp">
        <el-select v-model="value" placeholder="请选择" class="sele">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="value" placeholder="请选择" class="sele">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="itemnote flex_start"></div>
    </div>

    <div class="enform-item flex">
      <div class="label">涉案金额：</div>
      <div class="itinp">
        <el-select v-model="value1" placeholder="请选择">
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="itemnote flex_start"></div>
    </div>

    <div class="enform-item flex">
      <div class="label">委托状态</div>
      <div class="itinp flex_start">
        <label for="va1">
          <div class="wtzt">
            <input
              class="wtztradig"
              id="va1"
              type="radio"
              value="1"
              v-model="wtztradig"
            />
            <span>一般</span>
          </div>
        </label>
        <label for="va2">
          <div class="wtzt">
            <input
              class="wtztradig"
              id="va2"
              type="radio"
              v-model="wtztradig"
              value="2"
            />
            <span>紧急</span>
          </div>
        </label>

        <label for="va3">
          <div class="wtzt">
            <input
              class="wtztradig"
              id="va3"
              type="radio"
              v-model="wtztradig"
              value="3"
            />
            <span>求推荐</span>
          </div>
        </label>
      </div>
      <div class="itemnote flex_start"></div>
    </div>

    <div class="enform-item flex">
      <div class="label">您的称呼：</div>
      <div class="itinp">
        <el-input v-model="form.yq" placeholder="用户id"></el-input>
      </div>
      <div class="itemnote flex_start"></div>
    </div>

    <div class="enform-item flex nobod">
      <div class="label">电话号码：</div>
      <div class="itinp">
        <el-input v-model="form.yq"></el-input>
      </div>
      <div class="itemnote flex_start"></div>
    </div>

    <div class="enim flex">
      <div class="label"></div>
      <div class="itinp flex_start">
        <div class="subbtn">提交</div>
        <div class="ytjck">已提交，请<span>查看</span></div>
      </div>
      <div class="itemnote"></div>
    </div>

    
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      wtztradig: "1",
      options: [
        {
          value: "选项1",
          label: "安徽",
        },
        {
          value: "选项2",
          label: "山东",
        },
        {
          value: "选项3",
          label: "陕西",
        },
        {
          value: "选项4",
          label: "山西",
        },
        {
          value: "选项5",
          label: "北极",
        },
      ],
      value: "",
      options1: [
        {
          value: "选项1",
          label: "0-1万",
        },
        {
          value: "选项2",
          label: "1万-2万",
        },
        {
          value: "选项3",
          label: "2万-3万",
        },
      ],
      value1: "",
    };
  },
};
</script>
<style lang="scss" scoped>
.enformzw {
  background: #ffffff;
  .formheader {
    padding: 15px 45px;
    font-size: 16px;
    color: #999999;
    border: 1px solid #eeeeee;
    span {
      color: #258bf9;
    }
  }
  .enform-item {
    border-bottom: 1px solid #dddddd;
    padding: 30px;
    align-items: center;
    .label {
      width: 190px;
      font-size: 22px;
      color: #333333;
      padding-left: 15px;
    }
    .itinp {
      width: 550px;
    }
    .itemnote {
      width: 460px;
      align-items: flex-start;
      font-size: 14px;
      color: #999999;
      line-height: 26px;
      padding-left: 20px;
      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .sele {
      width: 150px;
      margin-right: 30px;
    }
    .wtzt {
      margin-right: 100px;
      span {
        position: relative;
        top: 2px;
        left: 20px;
      }
      .wtztradig {
        width: 18px;
        height: 18px;
        appearance: none;
        position: relative;
        top: -1px;
        outline: none;
        &:before {
          content: "";
          width: 26px;
          height: 26px;
          border: 1px solid #dddddd;
          display: inline-block;
          vertical-align: middle;
        }
        &:checked:before {
          content: "";
          width: 26px;
          height: 26px;
          border: 1px solid #dddddd;
          background: #fff;
          display: inline-block;
          vertical-align: middle;
        }
        &:checked:after {
          content: "";
          width: 20px;
          height: 10px;
          border: 2px solid #0465ea;
          border-top: transparent;
          border-right: transparent;
          text-align: center;
          display: block;
          position: absolute;
          top: 4px;
          left: 3px;
          transform: rotate(-50deg);
        }
      }
    }
    &.nobod {
      border-bottom: none;
    }
  }
  .enim {
    padding: 10px 30px 50px;
    align-items: center;
    .label {
      width: 190px;
    }
    .itinp {
      width: 550px;
    }
    .itemnote {
      width: 460px;
    }
    .subbtn {
      width: 150px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 20px;
      color: #ffffff;
      background: #0465ea;
      cursor: pointer;
    }
    .ytjck {
      margin-left: 20px;
      font-size: 20px;
      color: #999999;
      line-height: 50px;
      span{
          color: #0465EA;
      }
    }
  }
}
</style>